import { BaseBeneficiaryMeta } from '/@/modules/estateaccount/models/meta/BaseBeneficiaryMeta';
import { BeneficiaryGuardianCategory } from '/@/modules/beneficiary/enums/BeneficiaryGuardianCategory';
import { PlanningBeneficiaryCaredBy } from '@/modules/beneficiary/enums/PlanningBeneficiaryCaredBy';

export class BeneficiaryChildMeta extends BaseBeneficiaryMeta {
  /**
   * @var {string}
   */
  relationshipType;

  /**
   * @var {string}
   */
  otherRelationshipType;

  /**
   * @var {string}
   */
  guardianName;

  /**
   * @var {boolean}
   */
  hasMarriageCertificate;

  /**
   * @var {string}
   */
  missingMarriageCertificateNote;

  /**
   * @var {boolean}
   */
  hasCommonLawChildren;

  /**
   * @var {boolean}
   */
  hasJointResidentialProperty;

  /**
   * @var {boolean}
   */
  hasJointInvestmentProperty;

  /**
   * @var {boolean}
   */
  hasJointFinancialInstitutionAccount;

  /**
   * @var {boolean}
   */
  deceasedIsBeneficiaryOfLifeInsurance;

  /**
   * @var {boolean}
   */
  isBeneficiaryOfDeceasedLifeInsurance;

  /**
   * @var {boolean}
   */
  otherDocumentaryEvidence;

  /**
   * @var {boolean}
   */
  isFullTimeStudent;

  /**
   * @var {boolean}
   */
  isReceivingCpp;

  /**
   * @var {boolean}
   */
  isReceivingQpp;

  /**
   * @var {boolean}
   */
  isSupportingAllChildren;

  /**
   * @var {string}
   */
  isSupportingAllChildrenExplanation;

  /**
   * @var {string}
   */
  evidenceOfCommonLawRelationship;

  /**
   * @var {boolean}
   */
  wasUnbornAtDeath;

  /**
   * @var {boolean}
   */
  hasMentalDisability;

  /**
   * @var {boolean}
   */
  isNotServed;

  /**
   * @var {string}
   */
  unservedReason;

  /**
   * @var {string}
   */
  otherUnservedReason;

  /**
   * @var {boolean}
   */
  hasLegalGuardian;

  /**
   * @var {boolean}
   */
  hasCareGiver;

  /**
   * @var {boolean}
   */
  hasBiologicalCareGiver;

  /**
   * @var {?string}
   */
  guardianCategory;

  /**
   * @var {?string}
   */
  caredByGovernmentEntity;

  /**
   * @var {boolean}
   */
  hasCohabitationAgreement;

  /**
   * @var {boolean}
   */
  isNextOfKin;

  /**
   * @var {boolean}
   */
  willActAsPersonalRepresentative;

  /**
   * @var {string}
   */
  reasonForExecutorship;

  /**
   * @var {string}
   */
  reasonForExecutorshipOtherExplanation;

  constructor(model = {}) {
    super(model);

    this.relationshipType = model.relationshipType;
    this.otherRelationshipType = model.otherRelationshipType;
    this.guardianName = model.guardianName;
    this.hasMarriageCertificate = model.hasMarriageCertificate;
    this.missingMarriageCertificateNote = model.missingMarriageCertificateNote;
    this.hasCommonLawChildren = model.hasCommonLawChildren;
    this.hasJointResidentialProperty = model.hasJointResidentialProperty;
    this.hasJointInvestmentProperty = model.hasJointInvestmentProperty;
    this.hasJointFinancialInstitutionAccount = model.hasJointFinancialInstitutionAccount;
    this.deceasedIsBeneficiaryOfLifeInsurance = model.deceasedIsBeneficiaryOfLifeInsurance;
    this.isBeneficiaryOfDeceasedLifeInsurance = model.isBeneficiaryOfDeceasedLifeInsurance;
    this.otherDocumentaryEvidence = model.otherDocumentaryEvidence;
    this.isFullTimeStudent = model.isFullTimeStudent;
    this.isReceivingCpp = model.isReceivingCpp;
    this.isReceivingQpp = model.isReceivingQpp;
    this.isSupportingAllChildren = model.isSupportingAllChildren;
    this.isSupportingAllChildrenExplanation = model.isSupportingAllChildrenExplanation;
    this.evidenceOfCommonLawRelationship = model.evidenceOfCommonLawRelationship;
    this.wasUnbornAtDeath = model.wasUnbornAtDeath;
    this.hasMentalDisability = model.hasMentalDisability;
    this.isNotServed = model.isNotServed;
    this.unservedReason = model.unservedReason;
    this.otherUnservedReason = model.otherUnservedReason;
    this.hasLegalGuardian = model.hasLegalGuardian;
    this.hasCareGiver = model.hasCareGiver;
    this.hasBiologicalCareGiver = model.hasBiologicalCareGiver;
    this.guardianCategory = this.hasLegalGuardian ? model.guardianCategory : null;
    this.hasCohabitationAgreement = model.hasCohabitationAgreement;
    this.isNextOfKin = model.isNextOfKin;
    this.willActAsPersonalRepresentative = model.willActAsPersonalRepresentative;
    this.reasonForExecutorship = model.reasonForExecutorship;
    this.reasonForExecutorshipOtherExplanation = model.reasonForExecutorshipOtherExplanation;

    this.setCaredByGovernmentEntity(model.caredByGovernmentEntity);
  }

  setCaredByGovernmentEntity(value) {
    this.caredByGovernmentEntity =
      BeneficiaryGuardianCategory.isUnderPublicGuardianship(this.guardianCategory) ||
      PlanningBeneficiaryCaredBy.isCaredByGovernmentAgency(this.guardianCategory)
        ? value
        : '';
  }
}
